export default "__VITE_ASSET__DWOvIyVm__"